import React from 'react';
import { Lock, Shield, ArrowLeft, Mail } from 'lucide-react';
import { Link } from "react-router-dom";




const AccessDenied = () => {
    return (
      <div id="admin-container" style={{
        display: 'flex',
        minHeight: '90vh',
        backgroundColor: '#f9fafb'
      }}>
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px'
        }}>
          <div style={{
            maxWidth: '400px',
            width: '100%'
          }}>
            {/* Main Card */}
            <div style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
              border: '1px solid #f3f4f6',
              overflow: 'hidden'
            }}>
              {/* Header with Icon */}
              <div style={{
                background: 'linear-gradient(to right, #ef4444, #dc2626)',
                padding: '32px 32px 24px',
                textAlign: 'center'
              }}>
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '64px',
                  height: '64px',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '50%',
                  marginBottom: '16px'
                }}>
                  <Shield size={32} color="white" />
                </div>
                <h1 style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  color: 'white',
                  marginBottom: '8px',
                  margin: '0 0 8px 0'
                }}>Access Restricted</h1>
                <p style={{
                  color: '#fecaca',
                  fontSize: '14px',
                  margin: 0
                }}>
                  You don't have permission
                </p>
              </div>

              {/* Content */}
              <div style={{
                padding: '32px'
              }}>
                <div style={{
                  textAlign: 'center',
                  marginBottom: '24px'
                }}>
                  <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#fef2f2',
                    borderRadius: '50%',
                    marginBottom: '16px'
                  }}>
                    <Lock size={24} color="#ef4444" />
                  </div>
                  <p style={{
                    color: '#6b7280',
                    fontSize: '14px',
                    lineHeight: '1.6',
                    margin: 0
                  }}>
                    This section requires special privileges. Please contact your administrator 
                    or check with your team lead for access permissions.
                  </p>
                </div>

                {/* Action Buttons */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px'
                }}>
                  <Link to= "/inventory/add_Item_Category">
                  <button style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    backgroundColor: '#f3f4f6',
                    color: '#374151',
                    fontWeight: '500',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    fontSize: '14px'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                  >
                     <ArrowLeft size={16} />
                    Go Back
                  </button>
                  </Link>
                </div>
              </div>

              {/* Footer */}
              <div style={{
                backgroundColor: '#f9fafb',
                padding: '16px 32px',
                borderTop: '1px solid #f3f4f6'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  color: '#6b7280'
                }}>
                  
                  <Shield size={12} style={{ marginRight: '4px' }} />
                  Secure Access Control
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }

export default AccessDenied;